import React from 'react';
import { LuxuryNADPage } from './pages/LuxuryNADPage';
export function App() {
  return <LuxuryNADPage data-id="element-0" />;
}